module.exports = __webpack_public_path__ + "static/media/IMG-20200711-WA0086-ink.a65e8351.jpeg";